import { render } from "./ObjectListIFrame.vue?vue&type=template&id=6267e01c&ts=true"
import script from "./ObjectListIFrame.ts?vue&type=script&lang=ts&external"
export * from "./ObjectListIFrame.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__